import { useTranslation } from 'react-i18next';

export function AITeacherPage() {
  const { t } = useTranslation();
  return (
    <div>
      <h1 className="mb-6 text-2xl font-bold">{t('ai.title')}</h1>
      <p className="text-gray-500">AI Teacher chat coming soon...</p>
    </div>
  );
}
